import React from 'react'
import styled from 'styled-components'
import { PageProps } from 'gatsby'

import CMS from '@talus-analytics/library.airtable-cms'
import Providers, { Config } from 'components/layout/Providers'

import { ContentContainer, Main, Nav, Footer, Layout } from 'components/layout'
import { ActionButton, RichText } from 'components/ui'
import useAboutPageData from 'cmsHooks/useAboutPageData'

const Tagline = styled.p`
  ${({ theme }) => theme.textStyleTagLine}
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  padding: 1.5rem 0;
`
const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  p {
    max-width: 800px;
  }
`
const Spacer = styled.div`
  padding-top: 2em;
`

const AboutPage = ({ pageContext }: PageProps): JSX.Element => {
  const data = useAboutPageData()

  // cast pageContext to correct type
  const config = pageContext as Config

  return (
    <Providers config={config}>
      <Layout>
        {/* TODO: get SEO title from Airtable */}
        <CMS.SEO title={'About'} />
        <Nav />
        <Main>
          <ContentContainer>
            <FlexContainer>
              <h1>
                <CMS.Text data={data} name="First header" />
              </h1>
              <Tagline>
                <CMS.Text data={data} name="Tagline" />
              </Tagline>
              <RichText>
                <CMS.RichText data={data} name="Paragraph text" />
              </RichText>
              <Spacer />
              <ActionButton
                as="a"
                href={CMS.getText(data, 'Button link')}
                target="_blank"
              >
                <CMS.Text data={data} name="Button text" />
              </ActionButton>
            </FlexContainer>
          </ContentContainer>
        </Main>
        <Footer />
      </Layout>
    </Providers>
  )
}

export default AboutPage
